import i18next from './LocalizedStrings'

export const THEME = {
    LIGHT: {
        themeName: 'LIGHT',
        backgroundColor: '#E5E5E5',
        lineColor: '#00000045',
        textColor: '#000000DE',
        textSecondaryColor: '#0000008A',
        textDisableColor: '#00000045',
        linkTextColor: '#190DAB',
        toolTipTextColor: 'black',
        toolTipLabelColor: '#4682B4',
        crossCursorColor: '#000000',
        barChartUpColor: 'red',
        barChartDownColor: 'blue',
        barChartStrokeColor: '#000000',
        areaChartColor: '#ff7f0e',
        lineChartColor: 'blue',
        naviBarColor: '#E5E5E5',
        cardBgColor: '#FFFFFF',
        cardBorderColor: '#00000045',
        positiveColor: '#1EB980',
        negativeColor: '#FF6859',
        mouseEdgeAppearance: {
            textFill: "#542605",
            stroke: "#05233B",
            strokeOpacity: 1,
            strokeWidth: 3,
            arrowWidth: 5,
            fill: "#BCDEFA"
        },
    },
    DARK: {
        themeName: 'DARK',
        backgroundColor: '#33333D',
        lineColor: '#FFFFFF1F',
        textColor: '#FFFFFF',
        textSecondaryColor: '#FFFFFF8A',
        textDisableColor: '#FFFFFF45',
        linkTextColor: '#61dafb',
        toolTipTextColor: 'white',
        toolTipLabelColor: '#FFD300',
        crossCursorColor: '#FFFFFF',
        barChartUpColor: 'red',
        barChartDownColor: 'blue',
        barChartStrokeColor: '#FFFFFF',
        areaChartColor: '#ff7f0e',
        lineChartColor: 'blue',
        naviBarColor: '#3A3C45',
        cardBgColor: '#37373F',
        cardBorderColor: '#00000045',
        positiveColor: '#1EB980',
        negativeColor: '#FF6859',
        mouseEdgeAppearance: {
            textFill: "#542605",
            stroke: "#05233B",
            strokeOpacity: 1,
            strokeWidth: 3,
            arrowWidth: 5,
            fill: "#BCDEFA"
        },
    },

    getChartPositiveColor: function () {
        if (i18next.getLocal() === 'KR') {
            return 'red'
        } else if (i18next.getLocal() === 'JP') {
            return 'red'
        } else {
            return '#439641'
        }
    },

    getChartNegativeColor: function () {
        if (i18next.getLocal() === 'KR') {
            return 'blue'
        } else if (i18next.getLocal() === 'JP') {
            return 'blue'
        } else {
            return '#eb4844'
        }
    },

    getValuePositiveColor: function () {
        const local = i18next.getLocal()

        if (local === 'KR') {
            return '#e93529'
        } else if (local === 'JP') {
            return '#1EB980'
        } else {
            return '#1EB980'
        }
    },

    getValueNegativeColor: function () {
        const local = i18next.getLocal()

        if (local === 'KR') {
            return 'blue'
        } else if (local === 'JP') {
            return '#FF6859'
        } else {
            return '#FF6859'
        }
    },
}